const NL_TZ = 'Europe/Amsterdam';

/** Zelfde regels als server/lib/datetime-stored.js */
export function parseStoredInstant(value) {
  if (value == null || value === '') return null;
  const s = String(value).trim();
  if (!s) return null;

  if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}/.test(s) && !/Z$|[+-]\d{2}:\d{2}$/.test(s)) {
    const iso = s.replace(' ', 'T');
    const d = new Date(`${iso}Z`);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatDateTimeNl(value, options = {}) {
  const d = value instanceof Date ? value : parseStoredInstant(value);
  if (!d) return '—';
  return d.toLocaleString('nl-NL', {
    timeZone: NL_TZ,
    ...options,
  });
}
